import { call, fork, put, takeLatest } from 'redux-saga/effects';
import type {
  AnalyticsOverviewResponseDto,
  AnalyticsRoomsResponseDto,
} from '@poker-stats/contracts';
import apiService from '../../api/apiServices/apiService';
import i18n from '../../../i18n';
import {
  loadAnalyticsOverview,
  loadAnalyticsOverviewFailed,
  loadAnalyticsRooms,
  loadAnalyticsRoomsFailed,
  setAnalyticsOverview,
  setAnalyticsRooms,
} from './reducer';

function errorMessage(
  reject: { payload?: { message?: string } },
  fallbackKey: 'admin_analytics_overview_failed' | 'admin_analytics_rooms_failed',
): string {
  return reject.payload?.message || i18n.t(fallbackKey);
}

function* loadOverviewWorker(action: ReturnType<typeof loadAnalyticsOverview>) {
  const { success, reject } = yield call(
    [apiService, apiService.getAnalyticsOverview],
    action.payload,
  );
  if (success) {
    yield put(setAnalyticsOverview(success.payload as AnalyticsOverviewResponseDto));
  }
  if (reject) {
    yield put(loadAnalyticsOverviewFailed(errorMessage(reject, 'admin_analytics_overview_failed')));
  }
}

function* loadRoomsWorker(action: ReturnType<typeof loadAnalyticsRooms>) {
  const { success, reject } = yield call(
    [apiService, apiService.getAnalyticsRooms],
    action.payload,
  );
  if (success) {
    yield put(setAnalyticsRooms(success.payload as AnalyticsRoomsResponseDto));
  }
  if (reject) {
    yield put(loadAnalyticsRoomsFailed(errorMessage(reject, 'admin_analytics_rooms_failed')));
  }
}

function* watchOverview() {
  yield takeLatest(loadAnalyticsOverview.type, loadOverviewWorker);
}

function* watchRooms() {
  yield takeLatest(loadAnalyticsRooms.type, loadRoomsWorker);
}

export default function* analyticsSaga() {
  yield fork(watchOverview);
  yield fork(watchRooms);
}
